export function languageDropDown() {
    let $langList = $('.js--lang__list'),
        jsLang = ".js--lang";

    $(jsLang).on('click', function () {
        $langList.fadeToggle( "fast", "linear" );
    });

    $(document).on('click', function (e) {
        if (!e.target.closest(jsLang)) {
            $langList.fadeOut( "fast", "linear" );
        }
    });
}


// WEBPACK FOOTER //
// ./private/blocks/lang/lang.js